import { useState } from 'react';

interface GalleryProps {
  images: string[];
  title: string;
}

export default function Gallery({ images, title }: GalleryProps) {
  const [current, setCurrent] = useState(0);

  if (images.length === 0) {
    return <div className="w-full aspect-video rounded-lg bg-background-800" />;
  }

  const go = (dir: number) => {
    setCurrent((prev) => (prev + dir + images.length) % images.length);
  };

  return (
    <div>
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-background-800">
        <img
          src={images[current]}
          alt={`${title} 剧照 ${current + 1}`}
          title={`${title} 剧照 - 成人短剧详情`}
          className="w-full h-full object-cover object-top animate-fade-in"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent" />
        {images.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="上一张剧照"
              className="absolute left-3 top-1/2 -translate-y-1/2 flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-full bg-background-950/60 backdrop-blur text-foreground-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="下一张剧照"
              className="absolute right-3 top-1/2 -translate-y-1/2 flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-full bg-background-950/60 backdrop-blur text-foreground-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
            <span className="absolute bottom-3 right-3 rounded-md bg-background-950/70 backdrop-blur px-2.5 py-1 text-xs text-foreground-200">
              {current + 1} / {images.length}
            </span>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div className="mt-3 flex gap-2.5 overflow-x-auto no-scrollbar">
          {images.map((img, index) => (
            <button
              key={img}
              type="button"
              onClick={() => setCurrent(index)}
              aria-label={`查看第 ${index + 1} 张剧照`}
              className={`relative h-14 w-24 shrink-0 overflow-hidden rounded-md transition-all cursor-pointer ${
                index === current ? 'ring-2 ring-primary-500' : 'opacity-60 hover:opacity-100'
              }`}
            >
              <img src={img} alt={`${title} 剧照缩略图 ${index + 1}`} title={`${title} 剧照`} className="w-full h-full object-cover object-top" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}